import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle, } from '@mui/material';
import { Close, SaveOutlined } from '@mui/icons-material';
import { getPatientById } from '~/api/tasks/getPatientById';
import { getPatientByReportId } from '~/api/tasks/getPatientByReportId';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Button from '@mui/material/Button';
import axios from 'axios';
import { FormError } from '~/components/form/FormError';
import { useQueryClient } from 'react-query';
import { SingleUserSelectorLayout } from './SingleUserSelectorLayout';
const formSchema = yup
    .object({
    taskName: yup.string().required('Select a value'),
    taskContent: yup.string().required('Select a value'),
    assignedTo: yup.string().required('Select a value'),
    dueDate: yup.date().required('Select a value')
})
    .required();
export const AddTaskModal = (props) => {
    const { onRequestClose, url, onTaskAdded } = props;
    const [patientId, setPatientId] = useState(null);
    const [patientDisplayName, setPatientDisplayName] = useState('');
    // const [users, setUsers] = useState<IUser[]>([]);
    const queryClient = useQueryClient();
    useEffect(() => {
        if (url.includes('patient')) {
            const patientId = url.split('/').pop();
            getPatientByIdFunction(patientId);
        }
        if (url.includes('report')) {
            const reportId = url.split('/').pop();
            getPatientByReportIdFunction(reportId);
        }
        // getUsersForClinic();
    }, []);
    const getPatientByIdFunction = async (patientId) => {
        const patientInformation = await getPatientById({ patientId });
        setPatientDisplayName(patientInformation.data['display_name']);
        setPatientId(patientInformation.data['patient_id']);
    };
    const getPatientByReportIdFunction = async (reportId) => {
        const patientInformation = await getPatientByReportId({ reportId });
        setPatientDisplayName(patientInformation.data['display_name']);
        setPatientId(patientInformation.data['patient_id']);
    };
    // const getUsersForClinic = async() => {
    //   const users = await getUsersForPractice();
    //   setUsers(users.users);
    // };
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            taskName: '',
            taskContent: '',
            assignedTo: '',
            dueDate: new Date()
        }
    });
    const { formState: { isSubmitting, errors }, handleSubmit, register, setValue, getValues } = methods;
    // const handleChange = (event: SelectChangeEvent) => {
    //   const {
    //     target: { value },
    //   } = event;
    //   setValue('assignedTo',value);
    // };
    const onFormSubmit = async ({ taskName, taskContent }) => {
        const data = {
            taskName,
            taskContent,
            assignedTo: getValues('assignedTo'),
            dueDate: dayjs(getValues('dueDate')).format('YYYY-MM-DD'),
            patientId
        };
        const response = await axios.post('/api/tasks/addTask', data);
        console.log(response);
        alert('Task saved successfully');
        queryClient.invalidateQueries(['tasksCount']);
        queryClient.invalidateQueries(['tasksForPractice']);
        onRequestClose();
        onTaskAdded();
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { width: '100%' } // Adjust height as needed
        } },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" },
            "Add Task",
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", null,
                        patientId &&
                            React.createElement("div", { style: { padding: '10px', marginTop: '5px', marginBottom: '5px' } },
                                React.createElement("div", { style: { marginBottom: '2px', width: '100%', color: '#121417', fontSize: 16, fontFamily: 'Barlow', fontWeight: '600' } }, "Patient"),
                                React.createElement("div", null, patientDisplayName)),
                        React.createElement("div", { style: { padding: '10px', marginTop: '5px', marginBottom: '5px' } },
                            React.createElement("div", { style: { marginBottom: '2px', width: '100%', color: '#121417', fontSize: 16, fontFamily: 'Barlow', fontWeight: '600' } }, "Task Name"),
                            React.createElement("div", null,
                                React.createElement("input", { style: {
                                        padding: '5px',
                                        width: '100%',
                                        border: '1px solid #0000003B',
                                        borderRadius: '4px',
                                        height: '35px'
                                    }, placeholder: 'Enter Task Name', ...register('taskName') }))),
                        React.createElement("div", { style: { padding: '10px', marginTop: '5px', marginBottom: '5px' } },
                            React.createElement("div", { style: { marginBottom: '2px', width: '100%', color: '#121417', fontSize: 16, fontFamily: 'Barlow', fontWeight: '600' } }, "Assign To"),
                            React.createElement("div", null,
                                React.createElement(SingleUserSelectorLayout, { setSelectedUser: (val) => setValue('assignedTo', val), placeholder: 'Select User' }))),
                        React.createElement("div", { style: { padding: '10px', marginTop: '5px', marginBottom: '5px' } },
                            React.createElement("div", { style: { marginBottom: '2px', width: '100%', color: '#121417', fontSize: 16, fontFamily: 'Barlow', fontWeight: '600' } }, "Due Date"),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { style: { width: '200px' } },
                                    React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                        React.createElement(DatePicker, { value: dayjs(getValues('dueDate')), minDate: dayjs(), onChange: (value) => {
                                                if (value) {
                                                    setValue('dueDate', new Date(value.toString()));
                                                }
                                            } }))))),
                        React.createElement("div", { style: { padding: '10px', marginTop: '5px', marginBottom: '5px' } },
                            React.createElement("div", { style: { marginBottom: '2px', width: '100%', color: '#121417', fontSize: 16, fontFamily: 'Barlow', fontWeight: '600' } }, "Notes"),
                            React.createElement("div", null,
                                React.createElement("textarea", { style: {
                                        padding: '5px',
                                        width: '100%',
                                        border: '1px solid #0000003B',
                                        borderRadius: '4px',
                                        height: '85px',
                                        overflowY: 'scroll',
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: '#888 transparent'
                                    }, placeholder: 'Enter Notes', ...register('taskContent') }))),
                        React.createElement(FormError, { errors: errors, name: "addtask" }),
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary", startIcon: React.createElement(SaveOutlined, null) }, isSubmitting ? 'Submitting...' : 'Save Changes')))))));
};
